import moment from 'moment';
import _ from 'lodash';

class BarcodeUtil {
        static printObjectFields = [
            {field: "id", sourceField: "__id" , type: "string"},
            {field: "hospitalNumber", type: "string"},
            {field: "nhsNumber", type: "string"},
            {field: "firstName", type: "string"},
            {field: "middleName", sourceField: "middleNames", type: "string"},
            {field: "familyName", type: "string"},
            {field: "title", type: "string"},
            {field: "verificationStatusMarker", sourceField: "nhsVerificationStatusMarker", type: "string"},
            {field: "verificationStatus", sourceField: "nhsNumberVerifiedStatus", type: "string"},
            {field: "dob", type: "date", format: "DD/MM/YYYY"},
            {field: "age", type: "fn", fn: (p)=>{let d = moment(p.dob); return moment().diff(d, 'years'); } },
            {field: "sex", sourceField: "gender", type: "string"},
            {field: "addressLine1", type: "fn", fn: (p)=>{if(p.addressLines && p.addressLines.length > 0){ return p.addressLines[0]; } else { return ""; } }},
            {field: "addressLine2", type: "fn", fn: (p)=>{if(p.addressLines && p.addressLines.length > 1){ return p.addressLines[1]; } else { return ""; } }},
            {field: "addressLine3", type: "fn", fn: (p)=>{if(p.addressLines && p.addressLines.length > 2){ return p.addressLines[2]; } else { return ""; } }},
            {field: "addressLine4", type: "fn", fn: (p)=>{if(p.addressLines && p.addressLines.length > 3){ return p.addressLines[3]; } else { return ""; } }},
            {field: "postcode", sourceField: "postalCode", type: "string"},
            {field: "homeTelephone", sourceField: "homePhone", type: "string"},
            {field: "workTelephone", type: "fn", fn: (p) => {return p.workAndOtherPhone }},
            {field: "mobileTelephone", sourceField: "mobilePhone", type: "string"},
            {field: "email", sourceField: "emailAddress", type: "string"},
            {field: "gp", type: "object"},
            {field: "surgery", type:"object"},
            {field: "gNumber", type:"fn", fn: (p)=>{ return p.GNumber }},
            {field: "marital", type:"fn", fn: (p)=>{return p.maritalStatus != null ? p.maritalStatus.__description : ""}},
            {field: "language", sourceField: "primaryLanguage", type: "string"},
            {field: "ethnicOrigin", type:"fn", fn: (p)=>{return p.ethnicGroup != null ? p.ethnicGroup.__description : ""}},
            {field: "religion", type:"fn", fn: (p)=>{return p.religion != null ? p.religion.__description : ""}},
            {field: "kin", sourceField: "nok", type: "object"}];

       static printGPFields = [
            {field: "familyName", type: "string"},
            {field: "givenName", sourceField: "firstName" , type: "string"},
            {field: "initials" , type: "string"},
            {field: "gpId", sourceField: "__id" , type: "string"},
            {field: "title", sourceField: "title" , type: "string"},
            {field: "practiceCode", sourceField: "gpCode" , type: "string"},
            {field: "practiceName", sourceField: "surgery" , type: "string"},
            {field: "addressLine1", type: "fn", fn: (gp)=>{ if(gp.address && gp.address.lines && gp.address.lines.length > 0) return gp.address.lines[0]; return ""; }},
            {field: "addressLine2", type: "fn", fn: (gp)=>{ if(gp.address && gp.address.lines && gp.address.lines.length > 1) return gp.address.lines[1]; return ""; }},
            {field: "addressLine3", type: "fn", fn: (gp)=>{ if(gp.address && gp.address.lines && gp.address.lines.length > 2) return gp.address.lines[2]; return ""; }},
            {field: "addressLine4", type: "fn", fn: (gp)=>{ if(gp.address && gp.address.lines && gp.address.lines.length > 3) return gp.address.lines[3]; return ""; }},
            {field: "postcode" , type: "fn", fn: (gp)=>{ if(gp.address && gp.address.postalCode) return gp.address.postalCode; return ""; }},
            {field: "surgeryTelephone", sourceField: "phoneNumber" , type: "string"}
        ];

       static printSurgeryFields = [
            {field: "practiceCode", type: "string"},
            {field: "practiceName", type: "string"},
            {field: "primaryCareOrganisation", type: "fn", fn: (s)=>{ if(s.primaryCareOrganisation && s.primaryCareOrganisation.name) return s.primaryCareOrganisation.name; else return "";}},
            {field: "address1Line1", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 0) { if(s.addresses[0] && s.addresses[0].addressLines && s.addresses[0].addressLines.length > 0) return s.addresses[0].addressLines[0]; return ""; }}},
            {field: "address1Line2", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 0) { if(s.addresses[0] && s.addresses[0].addressLines && s.addresses[0].addressLines.length > 1) return s.addresses[0].addressLines[1]; return ""; }}},
            {field: "address1Line3", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 0) { if(s.addresses[0] && s.addresses[0].addressLines && s.addresses[0].addressLines.length > 2) return s.addresses[0].addressLines[2]; return ""; }}},
            {field: "address1Line4", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 0) { if(s.addresses[0] && s.addresses[0].addressLines && s.addresses[0].addressLines.length > 3) return s.addresses[0].addressLines[3]; return ""; }}},
            {field: "postcode1" , type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 0 && s.addresses[0].postalCode) return s.addresses[0].postalCode; return ""; }},
            {field: "address2Line1", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 1) { if(s.addresses[1] && s.addresses[1].addressLines && s.addresses[1].addressLines.length > 0) return s.addresses[1].addressLines[0]; return ""; }}},
            {field: "address2Line2", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 1) { if(s.addresses[1] && s.addresses[1].addressLines && s.addresses[1].addressLines.length > 1) return s.addresses[1].addressLines[1]; return ""; }}},
            {field: "address2Line3", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 1) { if(s.addresses[1] && s.addresses[1].addressLines && s.addresses[1].addressLines.length > 2) return s.addresses[1].addressLines[2]; return ""; }}},
            {field: "address2Line4", type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 1) { if(s.addresses[1] && s.addresses[1].addressLines && s.addresses[1].addressLines.length > 3) return s.addresses[1].addressLines[3]; return ""; }}},
            {field: "postcode2" , type: "fn", fn: (s)=>{ if(s.addresses && s.addresses.length > 1 && s.addresses[1].postalCode) return s.addresses[1].postalCode; return ""; }},
            {field: "surgeryPhone", type: "fn", fn: (s)=>{ return s.surgeryPhone }},
            {field: "surgeryFax", type: "fn", fn: (s)=>{ return s.surgeryFax }},
            {field: "surgeryEmail", type: "fn", fn: (s)=>{ return s.surgeryEmail }},
        ];

    static printNokFields = [
        {field: "firstName", sourceField: "firstName" , type: "string"},
        {field: "lastName", sourceField: "familyName" , type: "string"},
        {field: "addressLine1", type: "fn", fn: (k)=>{if(k.address && k.address.addressLines && k.address.addressLines.length > 0){ return k.address.addressLines[0]; } else { return ""; } }},
        {field: "addressLine2", type: "fn", fn: (k)=>{if(k.address && k.address.addressLines && k.address.addressLines.length > 1){ return k.address.addressLines[1]; } else { return ""; } }},
        {field: "addressLine3", type: "fn", fn: (k)=>{if(k.address && k.address.addressLines && k.address.addressLines.length > 2){ return k.address.addressLines[2]; } else { return ""; } }},
        {field: "addressLine4", type: "fn", fn: (k)=>{if(k.address && k.address.addressLines && k.address.addressLines.length > 3){ return k.address.addressLines[3]; } else { return ""; } }},
        {field: "postcode", type: "fn", fn: (k)=>{if(k.address && k.address.postalCode){ return k.address.postalCode; } else { return ""; }}},
        {field: "relationship", type: "fn", fn: (k)=>{if(k.relationship){ return k.relationship.getDisplayName() } else { return ""; }}},
        {field: "home", sourceField: "phoneNumber" , type: "string"},
        {field: "mobile", type: "fn", fn: ()=>{return "";}},
        {field: "work", sourceField: "businessPhoneNumber" , type: "string"}
    ];

    static preparePrintDataObj = (inputObj, alternative) => {
        const arrayFields = alternative ?? this.printObjectFields;
        let resObj = {};
        if (inputObj && arrayFields && Array.isArray(arrayFields)) {
            _.forEach(arrayFields, (c) => {
                switch (c.type) {
                    case 'date':
                        try {
                            if (c.hasOwnProperty('sourceField')) {
                                resObj[c.field] = moment(inputObj[c.sourceField]).format(c.format);
                            } else {
                                resObj[c.field] = moment(inputObj[c.field]).format(c.format);
                            }
                            if (resObj[c.field] == null) {
                                resObj[c.field] = '';
                            }
                        } catch (ex) {
                            console.warn(ex);
                            resObj[c.field] = '';
                        }
                        break;
                    case 'fn':
                        try {
                            resObj[c.field] = c.fn(inputObj);
                            if (resObj[c.field] == null) {
                                resObj[c.field] = '';
                            }
                        } catch (ex) {
                            console.warn(ex);
                            resObj[c.field] = '';
                        }
                        break;
                    case 'object':
                        try {
                            // eslint-disable-next-line default-case
                            switch (c.field) {
                                case 'gp':
                                    resObj[c.field] = this.preparePrintDataObj(inputObj[c.field], this.printGPFields);
                                    break;
                                case 'surgery':
                                    resObj[c.field] = this.preparePrintDataObj(inputObj[c.field], this.printSurgeryFields);
                                    break;
                                case 'kin':
                                    resObj[c.field] = this.preparePrintDataObj(inputObj[c.sourceField], this.printNokFields);
                                    break;
                            }
                        } catch (ex) {
                            console.warn(ex);
                            resObj[c.field] = '';
                        }
                        break;
                    case 'string':
                    default: {
                        try {
                            if (c.hasOwnProperty('sourceField')) {
                                if (inputObj[c.sourceField] === undefined || inputObj[c.sourceField] === null) {
                                    resObj[c.field] = '';
                                } else {
                                    resObj[c.field] = inputObj[c.sourceField].toString();
                                }
                            } else {
                                if (inputObj[c.field] == null) {
                                    resObj[c.field] = '';
                                } else {
                                    resObj[c.field] = inputObj[c.field].toString();
                                }
                            }
                            if (resObj[c.field] == null) {
                                resObj[c.field] = '';
                            }
                        } catch (ex) {
                            console.warn(ex);
                            resObj[c.field] = '';
                        }
                    }
                }
            });
        }
        return resObj;
    };

    static prepareBarcodeFormObj = (ptId, date) => {
        return {
            formName: 'barcode',
            formDate: date,
            formDateType: 'lookup',
            formKind: 'lookup',
            barcodeData: ptId + ' ' + date,
            specialtyName: '',
            frontSheetName: '',
            specialtyDchName: '',
            specialtyCode: '',
            wardName: '',
            wardCode: '',
            consultantName: '',
            clinicCode: '',
            docTypeCode: '',
            docTypeName: '',
        };
    };
}

export default BarcodeUtil